import type { Scene } from "@/data/schema/scene";
import type { MarkerAppearance } from "../../marker/MarkerPortrait/portrait";
import type { CharacterMarker, SceneBeat } from "./layout";

function resolvePovCharacterId(
  scene: Scene | undefined,
  characterIds: string[],
): string {
  if (scene !== undefined) {
    const pov = scene.participants.find((p) => p.role === "pov");
    if (pov !== undefined && characterIds.includes(pov.characterId)) {
      return pov.characterId;
    }
    const present = scene.participants.find(
      (p) => p.role === "present" && characterIds.includes(p.characterId),
    );
    if (present !== undefined) {
      return present.characterId;
    }
  }
  return characterIds[0];
}

export function resolveBeatPovCharacterId(
  scene: Scene | undefined,
  characterIds: string[],
): string {
  return resolvePovCharacterId(scene, characterIds);
}

export function buildCharacterMarkers(
  beats: SceneBeat[],
  nameById: Map<string, string>,
  imageById: Map<string, {
    imageUrl?: string;
    appearances: MarkerAppearance[];
  }>,
): CharacterMarker[] {
  const seen = new Set<string>();
  const markers: CharacterMarker[] = [];
  for (const beat of beats) {
    for (const characterId of beat.characterIds) {
      if (seen.has(characterId)) {
        continue;
      }
      seen.add(characterId);
      const portrait = imageById.get(characterId);
      markers.push({
        characterId,
        displayName: nameById.get(characterId) ?? characterId,
        appearances: portrait?.appearances ?? [],
        ...(portrait?.imageUrl === undefined
          ? {}
          : { imageUrl: portrait.imageUrl }),
      });
    }
  }
  return markers;
}
